function updateFloorplansData() {
  const isPresent = document.querySelector(".active-floorplan-section");
  if (!isPresent) {
    return;
  }

  const targetObjects = document.querySelectorAll(
    ".active-floorplan-section .floorplan-object"
  );

  targetObjects.forEach((target) => {
    const targetID = target.getAttribute("id");
    const source = document.querySelector(
      `.object-source-data__single[data-id='${targetID}']`
    );

    const status = source.getAttribute("data-status");
    const url = source.getAttribute("data-url");

    target.dataset.status = status;
    target.dataset.url = url;
  });
}

export { updateFloorplansData };
